<template>
  <div class="container-fluid p-0">
    <div
      v-if="canUserEdit"
      class="row"
    >
      <div class="ml-auto col-auto">
        <!-- Speichern Button -->
        <v-btn
          :disabled="isSaveDisabled || isLoading"
          :loading="isLoadingSave"
          color="success"
          fab
          small
          @click="handleSave"
        >
          <v-icon dark>
            save
          </v-icon>
        </v-btn>

        <!-- Bearbeiten Button -->
        <v-btn
          :disabled="isLoading"
          :loading="isLoadingCancel"
          color="secondary"
          fab
          small
          @click="handleCancel"
        >
          <v-icon dark>
            edit_off
          </v-icon>
        </v-btn>

        <!-- Löschen Button -->
        <v-btn
          v-if="isDeleteVisible"
          :disabled="isLoading"
          :loading="isLoadingDelete"
          color="primary"
          fab
          small
          @click="handleDelete"
        >
          <v-icon dark>
            delete
          </v-icon>
        </v-btn>
      </div>
    </div>

    <!-- Error Handling -->
    <u-error-handling
      v-if="errorObject"
      :error-object="errorObject"
    />

    <!-- Loader -->
    <u-loader v-if="isLoading" />

    <!-- Dynamischer Inhalt -->
    <slot v-else />

    <div
      v-if="canUserEdit"
      class="container-fluid p-0"
    >
      <div class="row">
        <div class="ml-auto col-auto">
          <!-- Speichern und Abbrechen Buttons -->
          <v-btn
            :disabled="isSaveDisabled || isLoading"
            :loading="isLoadingSave"
            color="success"
            @click="handleSave"
          >
            <i class="fas fa-save mr-2" /> Speichern
          </v-btn>
          <v-btn
            :disabled="isLoading"
            :loading="isLoadingCancel"
            color="secondary"
            @click="handleCancel"
          >
            <i class="fas fa-ban mr-2" /> Abbrechen
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TenantBaseLayout",
  props: {
    isSaveDisabled: {
      type: Boolean,
      default: false,
    },
    errorObject: {
      type: Object,
      default: () => ({}),
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    isDeleteVisible: {
      type: Boolean,
      default: true,
    },
    isLoadingCancel: {
      type: Boolean,
      default: false,
    },
    isLoadingSave: {
      type: Boolean,
      default: false,
    },
    isLoadingDelete: {
      type: Boolean,
      default: false,
    },
    canUserEdit: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleSave() {
      this.$emit("save");
    },
    handleCancel() {
      this.$emit("cancel-edit");
    },
    handleDelete() {
      this.$emit("delete");
    },
  },
};
</script>

<style scoped></style>
